import React, { useState } from 'react';
import BarcodeScanner from 'react-qr-barcode-scanner';
import './CodeScannerStyles.css';

const beepSound = new Audio('/assets/beep-sound.mp3');
beepSound.preload = 'auto';

const CodeScannerComponent = ({ onScanResult }) => {
  const [isScannerActive, setIsScannerActive] = useState(false);
  const [scannedResult, setScannedResult] = useState('');

  const handleScan = (err, result) => {
    if (result) {
      // Toca som
      beepSound.play().catch(console.error);
      
      const newResult = result.text;
      setScannedResult(newResult);
      onScanResult(newResult);
      
      // Feedback visual (piscar câmera)
      setIsScannerActive(false);
      setTimeout(() => {
        setIsScannerActive(true);
      }, 500); 
    }
  };

  return (
    <div className="d-flex flex-column h-100">
      <div className="flex-grow-1">
        {isScannerActive ? (
          <div className="qr-scanner-container shadow-sm">
            <BarcodeScanner
              width="100%"
              height="100%"
              onUpdate={handleScan}
            />
            {/* Linha vermelha de mira (opcional) */}
            <div style={{
                position: 'absolute', top: '50%', left: '10%', right: '10%', 
                height: '2px', backgroundColor: 'rgba(255, 0, 0, 0.6)', 
                boxShadow: '0 0 4px red'
            }}></div>
          </div>
        ) : (
          <div className="scanner-placeholder">
            <i className="bi bi-camera-video-off fs-1 mb-3 opacity-50"></i>
            {scannedResult ? (
              <div className="animate-fade-in">
                <p className="mb-1 small text-uppercase fw-bold">Última Leitura</p>
                <div className="bg-white px-4 py-2 rounded shadow-sm border border-success">
                    <strong className="text-success fs-4">{scannedResult}</strong>
                </div>
              </div>
            ) : (
              <div>
                  <p className="mb-0">Câmera em pausa.</p>
                  <small>Clique abaixo para iniciar.</small>
              </div>
            )}
          </div>
        )}
      </div>

      <button
        onClick={() => setIsScannerActive(prev => !prev)}
        className={`scanner-toggle-button btn ${isScannerActive ? 'btn-outline-danger' : 'btn-primary shadow'}`}
      >
        {isScannerActive ? (
            <><i className="bi bi-stop-circle me-2"></i> Pausar Leitura</>
        ) : (
            <><i className="bi bi-play-circle me-2"></i> Ativar Câmera</>
        )}
      </button>
    </div>
  );
}

export default CodeScannerComponent;